import React from 'react';
import { Box } from 'rebass/styled-components';

import MainLayout from '../../components/layout/Main';
import useIframeMessage from '../../hooks/useIframeMessage';
import usePageTitle from '../../hooks/usePageTitle';

export const CompanyResearch = () => {
  usePageTitle('Company research');
  const iframeUrl = useIframeMessage('companyResearch');

  return (
    <MainLayout
      containerProps={{
        pb: 0,
        minHeight: '100vh',
      }}
    >
      <Box
        as="iframe"
        src={iframeUrl}
        title="Findem Company Research"
        sandbox="allow-forms allow-same-origin allow-scripts allow-popups"
        allow="clipboard-read; clipboard-write"
        sx={{
          width: '100%',
          height: 'calc(100vh - 64px)',
          border: 'none',
          flex: 1,
        }}
      />
    </MainLayout>
  );
};
